import { render, staticRenderFns } from "./ReaderForm.vue?vue&type=template&id=0af48526&scoped=true&"
import script from "./ReaderForm.vue?vue&type=script&lang=js&"
export * from "./ReaderForm.vue?vue&type=script&lang=js&"
import style0 from "./ReaderForm.vue?vue&type=style&index=0&id=0af48526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af48526",
  null
  
)

export default component.exports